import React from 'react';
import { Card } from '@/components/ui/card';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function StatCardEnhanced({ 
  title, 
  value, 
  icon: Icon, 
  color = 'text-blue-600',
  bgColor = 'bg-blue-50',
  trend,
  trendLabel = 'geçen aya göre',
  link,
  sparklineData = []
}) {
  const navigate = useNavigate();
  const hasTrend = trend !== undefined && trend !== null;
  const trendPositive = trend > 0;
  
  return (
    <Card 
      className={`p-6 hover:-translate-y-1 hover:shadow-xl transition-all cursor-pointer ${link ? 'hover:border-blue-400' : ''}`}
      onClick={() => link && navigate(link)}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground font-medium">{title}</p>
          <p className="text-4xl font-bold mt-2 bg-gradient-to-br from-gray-900 to-gray-600 bg-clip-text text-transparent">
            {value}
          </p>
          
          {hasTrend && (
            <div className={`flex items-center gap-1 mt-2 text-sm font-semibold ${
              trendPositive ? 'text-green-600' : 'text-red-600'
            }`}>
              {trendPositive ? <TrendingUp className="w-4 h-4" /> : <TrendingDown className="w-4 h-4" />}
              <span>{trendPositive ? '+' : ''}{trend}%</span>
              <span className="text-xs text-muted-foreground font-normal">{trendLabel}</span>
            </div>
          )}
        </div>
        
        <div className={`${bgColor} p-4 rounded-xl`}>
          <Icon className={`w-10 h-10 ${color}`} />
        </div>
      </div>
      
      {sparklineData && sparklineData.length > 0 && (
        <div className="h-12 flex items-end gap-1">
          {sparklineData.map((val, i) => (
            <div
              key={i}
              className={`flex-1 rounded-t ${trendPositive ? 'bg-green-200' : 'bg-blue-200'}`}
              style={{ height: `${(val / Math.max(...sparklineData)) * 100}%` }}
            />
          ))}
        </div>
      )}
    </Card>
  );
}
